const dashboard = {
  dashboard: {
    title: 'Dashboard',
    switchToClassic: 'Overschakelen naar klassieke weergave',
    comingSoon: 'æKomt binnenkort',
    companyScoreCard: 'Bedrijfsprestatiescorecard',
    enphaseSince: 'Installeert Enphase sinds',
    sitesCommissioned: 'Aantal werklocaties',
    microinverters: 'Micro-omvormers geïnstalleerd',
    batteriesInstalled: 'Geïnstalleerde batterijen',
    nps: 'Netto Promotor Score',
    ensembleCertified: 'Opslag Erkend Installatiebedrijf',
    einLearn: 'Meer informatie over EIN',
    yes: 'Ja',
    no: 'Geen',
    lastMonth: {
      one: 'in de afgelopen 1 maand',
      other: 'in de laatste %{count} maanden'
    },
    congratulations: 'Gefeliciteerd!',
    acceptInvitation: 'Accepteer uitnodiging',
    einInvitation: 'U heeft een uitnodiging ontvangen om deel te nemen aan het Enphase Installer Network.',
    leadsInvitation: 'U heeft een uitnodiging ontvangen om deel te nemen aan het Enphase Leads Programma.',
    announcements: 'Aankondigingen',
    systems: 'Systemen',
    all: 'Allemaal',
    alerts: 'Waarschuwingen',
    activations: 'Activeringen',
    leads: 'Leads',
    search: 'Zoeken op',
    noResult: 'Geen resultaten gevonden',
    viewActivations: 'Bekijk alle activeringen',
    viewLeads: 'Bekijk alle leads',
    viewSystems: 'Bekijk alle systemen',
    addNewSystems: 'Nieuw systeem toevoegen',
    total: 'Totaal',
    activatedSites: 'Geactiveerde sites',
    nameId: 'Naam / Id',
    status: 'Status',
    city: 'Stad',
    state: 'Regio / Prov',
    //TODO - new translation added
    leadSource: 'Lead Source',
    createNewLead: 'Create New Lead',
    //TODO ends
    notAvailable: 'Niet beschikbaar',
    quickAccess: 'Snelle toegang',
    contactUs: 'Contacteer ons',
    ensemble: 'Ensemble',
    serviceShortcuts: 'Service Snelkoppelingen',
    newsletter: 'Installateur Nieuwsbrief',
    service: 'Servicemanager',
    enphaseleads: 'Enphase Leads Programma',
    enphaseCommunity: 'Enphase Gemeenschap',
    enphaseStore: 'Enphase winkel',
    systemConfigurator: 'Systeemconfigurator',
    criticalUpdates: 'Kritieke updates',
    documentation: 'Documentatie',
    brandLibrary: 'Merbibliotheek',
    training: 'Opleiding',
    noContentAvailable: 'Geen inhoud beschikbaar',
    newsBoard: 'Nieuwsbord',
    viewEinDashboard: 'Bekijk het EIN Dashboard',
    enterComments: 'Voer uw opmerkingen in',
    maxAllowedComment: 'Maximaal %{maxCount} tekens zijn toegestaan',
    switchingBackNote:
      'Terugschakelen naar de klassieke versie van Enlighten Manager? Help ons de nieuwe versie te verbeteren door uw reden om terug te schakelen met ons te delen',
    switchBackTitle: 'Schakel over naar klassieke weergave voor een beperkte tijd',
    new: 'Nieuw',
    view: 'Bekijk',
    gridProfileToken: 'Rooster profiel wijziging token',
    ProfileTokenText: 'Profiel wijziging token',
    validText: 'Dit token is één dag geldig voor Envoy %{serialNumber}.',
    envoySerialNumber: 'Envoy Serienummer',
    authorizationNumber: 'Machtigingsnummer',
    getToken: 'Token ophalen',
    viewAll: 'Bekijk alles',
    viewFullList: 'Bekijk de volledige lijst',
    serviceRequests: 'Serviceverzoeken',
    inProgressRequests: 'In uitvoering',
    totalCases: 'Totaal aantal gevallen',
    resolvedRequests: 'Opgelost',
    viewDetails: 'Gegevens bekijken'
  }
};

export default dashboard;
